export const LINKS_PER_PAGE = 10;
export const GA_TRACKING_ID = 'UA-25237536-1';
export const GTM_ID = 'GTM-PVXQGN4';
export const RECAPTCHA_SITE_KEY = '6Le1bkgUAAAAAEcG4Fnd0tqYxE0UVGs_v5Zi-q8U';
export const AWS_CONTACT_ENDPOINT = 'https://jj9ccufgdk.execute-api.us-east-1.amazonaws.com/prod/api';



// WEBPACK FOOTER //
// ./src/constants.js